import { ZoomIn as ZoomInIcon } from "@mui/icons-material";
import { Box } from "@mui/material";

import { theme } from "@/src/theme/theme";

interface ZoomOverlayProps {
  isMobile: boolean;
  onImageClick?: () => void;
}

export const ZoomOverlay = ({ isMobile, onImageClick }: ZoomOverlayProps) => {
  if (!onImageClick) return null;

  return (
    <Box
      sx={{
        position: "absolute",
        top: 0,
        right: 0,
        width: isMobile ? "65px" : "75px",
        height: isMobile ? "65px" : "75px",
        backgroundColor: theme.palette.misc.backdropOverlay,
        clipPath: "polygon(0 0, 100% 0, 100% 100%)",
        zIndex: 25,
        cursor: "pointer",
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "flex-end",
        padding: isMobile ? "6px 6px 0 0" : "10px 10px 0 0",
        transition: "background-color 0.2s ease",
        pointerEvents: "none", // Allow clicking through to image, which handles opening lightbox
        backdropFilter: "blur(4px)",
        "&:hover": {
          backgroundColor: theme.palette.text.primary
        }
      }}
    >
      <ZoomInIcon
        sx={{
          color: theme.palette.common.white,
          fontSize: theme.typography.h3.fontSize
        }}
      />
    </Box>
  );
};
